import { render, staticRenderFns } from "./ContratoResponsaveis.vue?vue&type=template&id=0514afa7"
import script from "./ContratoResponsaveis.vue?vue&type=script&lang=js"
export * from "./ContratoResponsaveis.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports